export const ImageTypesEnum = {
    ProductImage:6
};
